import { useMutation, useQueryClient, useQuery } from "react-query";
import { makeAuthedRequest } from "utils/makeAuthedRequest";

export function useEmail() {
  const queryClient = useQueryClient();

  const confirmEmail = async ({ entityId, email }) => {
    const response = await makeAuthedRequest(
      `v1/settings/sub-entity/email/${entityId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      }
    );

    if (!response.ok) {
      const body = await response.json();
      throw new Error(body.message || "Failed to confirm email");
    }

    const text = await response.text();
    return text ? JSON.parse(text) : {};
  };

  return useMutation(confirmEmail, {
    onSuccess: () => {
      queryClient.invalidateQueries(["subEntityInfo"]);
    },
  });
}

export default useEmail;

export function useValidateAndVerifyEmail() {
  const validateUpdateEmail = useMutation(({ contactId, email }) =>
    makeAuthedRequest(`v1/settings/verify/email/send/${contactId}`, {
      method: "POST",
      body: JSON.stringify({ email }),
    }).then(async (res) => {
      if (res.ok) {
        return res;
      } else {
        const body = await res.json();
        throw new Error(body.message);
      }
    })
  );

  const verifyEmail = useMutation(async ({ email, code, contactId }) => {
    const response = await makeAuthedRequest(
      `v1/settings/verify/email/${contactId}`,
      {
        method: "POST",
        body: JSON.stringify({ email, code }),
      }
    );

    const textResponse = await response.text();

    let parsedResponse;
    try {
      parsedResponse = JSON.parse(textResponse);
    } catch (e) {
      parsedResponse = textResponse;
    }

    if (!response.ok) {
      throw new Error(parsedResponse.message || parsedResponse);
    }

    return parsedResponse;
  });

  return {
    validateUpdateEmail,
    verifyEmail,
  };
}

export function useVerifyEmail() {
  const queryClient = useQueryClient();

  const verifySubEntityEmail = useMutation(
    ({ entityId, email }) =>
      makeAuthedRequest(`v1/settings/sub-entity/email/${entityId}`, {
        method: "POST",
        body: JSON.stringify({ email }),
      }).then(async (res) => {
        if (res.ok) {
          return res;
        } else {
          const body = await res.json();
          throw new Error(body.message);
        }
      }),

    {
      onSuccess: () => {
        queryClient.invalidateQueries("subEntityInfo");
      },
      onError: (err) => {
        console.error("Error sending verification email:", err);
      },
    }
  );

  return {
    verifySubEntityEmail,
  };
}
